export default __webpack_public_path__ + "static/media/loading.e054ef0a.gif";